module.exports = __webpack_public_path__ + "static/media/customer_smaller.2e8809a5.jpg";